module.exports = __webpack_public_path__ + "static/media/7-check.9f752d9f.svg";